/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.75001 0.75H18.25C18.4931 0.75 18.7263 0.846577 18.8982 1.01849C19.0701 1.19039 19.1667 1.42355 19.1667 1.66667V16.3333C19.1667 16.5764 19.0701 16.8096 18.8982 16.9815C18.7263 17.1534 18.4931 17.25 18.25 17.25H1.75001C1.5069 17.25 1.27374 17.1534 1.10183 16.9815C0.929921 16.8096 0.833344 16.5764 0.833344 16.3333V1.66667C0.833344 1.42355 0.929921 1.19039 1.10183 1.01849C1.27374 0.846577 1.5069 0.75 1.75001 0.75ZM17.3333 4.63483L10.066 11.1432L2.66668 4.61467V15.4167H17.3333V4.63483ZM3.13509 2.58333L10.0559 8.69017L16.8768 2.58333H3.13509Z"
      fill="var(--primaryTheme)"
    />
  </svg>
);

export default EmailIcon;
